import { render, staticRenderFns } from "./ShowText.vue?vue&type=template&id=6f515d78&scoped=true&"
import script from "./ShowText.vue?vue&type=script&lang=js&"
export * from "./ShowText.vue?vue&type=script&lang=js&"
import style0 from "./ShowText.vue?vue&type=style&index=0&id=6f515d78&prod&scoped=true&lang=scss&"
import style1 from "./ShowText.vue?vue&type=style&index=1&id=6f515d78&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f515d78",
  null
  
)

export default component.exports